/**
 * @file        src/api/communicationLogs.js
 * @description Communication Log API calls (/api/communication-logs) — every
 *              outbound email attempt from either backend: customer-facing
 *              sends from booking_backend (booking confirmations, OTPs,
 *              hotel vouchers…) and admin-initiated sends from admin_backend
 *              (password reset, share-by-email). Read-only: this is a log
 *              viewer, no create/update/delete.
 * @author      Kinetika Labs
 * @created     2026-08-05
 * @changelog
 *   - 2026-09-22 Claude — getCommunicationLog(id): one entry with its stored
 *                          message body. Separate from the list, which stays
 *                          body-free on purpose.
 *   - 2026-08-05 Claude — Initial (Account Management → Communication Log).
 */
import { get } from './client';

/**
 * Paginated + filterable list.
 * params: { page, pageSize, brand, status, template, search, from, to }.
 * Response shape: { data: { rows, total, page, pageSize } }.
 */
export const listCommunicationLogs = (params) => get('/communication-logs', { params });

/**
 * One entry, WITH `body_html` / `body_text` — what the recipient actually got.
 * Both are null for a row sent before bodies were retained (migration 066) or
 * one whose body has passed the retention window.
 * Response shape: { data: { ...row, body_html, body_text } }.
 */
export const getCommunicationLog = (id) => get(`/communication-logs/${id}`);
